export default __webpack_public_path__ + "static/media/a016-6.f582219c.jpg";